export default __webpack_public_path__ + "static/media/quote-black.487338a2.svg";